import React, { useState, useEffect } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ onComplete }) => {
  const [showName, setShowName] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Show name after 2.5 seconds
    const nameTimer = setTimeout(() => {
      setShowName(true);
    }, 2500);

    // Complete loading after 4 seconds total
    const completeTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onComplete && onComplete();
      }, 500); // Allow fade out animation to complete
    }, 4000);

    return () => {
      clearTimeout(nameTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div className={`loading-screen ${!isVisible ? 'fade-out' : ''}`}>
      <div className="loading-container">
        {/* Logo SVG */}
        <div className="logo-container">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 100" className="stellar-logo">
            {/* Background (transparent for favicon) */}
            <rect width="100%" height="100%" fill="none"/>

            {/* Infinity loop outline */}
            <path d="M 30 50 C 30 20, 70 20, 100 50 
                     C 130 80, 170 80, 170 50 
                     C 170 20, 130 20, 100 50 
                     C 70 80, 30 80, 30 50 Z"
                  stroke="url(#grad)" strokeWidth="5" fill="none" strokeLinecap="round" className="infinity-loop"/>

            {/* Gradient for infinity loop */}
            <defs>
              <linearGradient id="grad" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="#38bdf8"/>
                <stop offset="100%" stopColor="#14b8a6"/>
              </linearGradient>
              
              {/* Glow filter for animations */}
              <filter id="glow">
                <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                <feMerge> 
                  <feMergeNode in="coloredBlur"/>
                  <feMergeNode in="SourceGraphic"/>
                </feMerge>
              </filter>
            </defs>

            {/* Core glowing star */}
            <circle cx="100" cy="50" r="6" fill="#38bdf8" className="core-star"/>
            <circle cx="100" cy="50" r="12" fill="none" stroke="#38bdf8" strokeWidth="2" opacity="0.6" className="core-glow"/>

            {/* Left loop (constellation) */}
            <circle cx="60" cy="35" r="3" fill="#fff" className="constellation-star"/>
            <circle cx="45" cy="65" r="3" fill="#fff" className="constellation-star"/>
            <circle cx="75" cy="65" r="3" fill="#fff" className="constellation-star"/>
            <line x1="45" y1="65" x2="60" y2="35" stroke="#38bdf8" strokeWidth="1.5" className="constellation-line"/>
            <line x1="60" y1="35" x2="75" y2="65" stroke="#38bdf8" strokeWidth="1.5" className="constellation-line"/>

            {/* Right loop (circuit) */}
            <line x1="125" y1="35" x2="150" y2="35" stroke="#14b8a6" strokeWidth="2" className="circuit-line"/>
            <line x1="150" y1="35" x2="150" y2="65" stroke="#14b8a6" strokeWidth="2" className="circuit-line"/>
            <line x1="150" y1="65" x2="125" y2="65" stroke="#14b8a6" strokeWidth="2" className="circuit-line"/>
            <circle cx="125" cy="35" r="3" fill="#14b8a6" className="circuit-node"/>
            <circle cx="125" cy="65" r="3" fill="#14b8a6" className="circuit-node"/>
          </svg>
        </div>

        {/* Name reveal */}
        <div className={`name-container ${showName ? 'show' : ''}`}>
          <h1 className="name-text">Dhiraj T H</h1>
          <div className="name-subtitle">AI Engineer • Innovator • Creator</div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;